export const REPORT = {
    airport: {
        enabled: true,
        categories: {
            keyStats: {
                enabled: true,
                title: 'Key Stats',
                items: {
                    goNoGo: { title: 'Go / No Go Rating', enabled: true },
                    medicalRiskRating: { title: 'Medical Risk Rating', enabled: true },
                    securityRiskRating: { title: 'Security Risk Rating', enabled: true },
                    covidImpact: { title: 'COVID Impact', enabled: true }
                }
            },
            overview: {
                enabled: true,
                title: 'Overview',
                items: {
                    runwaySpecs: { title: 'Runway Specs', enabled: true },
                    groundHandling: { title: 'Ground Handling', enabled: true },
                    airportEntry: { title: 'Airport Entry', enabled: true },
                    timeZone: { title: 'Time Zone', enabled: true },
                    airportContacts: { title: 'Airport Contacts', enabled: true },
                    airportMapURL: { title: 'Airport Map', enabled: true },
                    airportType: { title: 'Airport Type', enabled: true }
                }
            },
            operations: {
                enabled: true,
                title: 'Operations',
                items: {
                    airportSummary: { title: 'Airport Summary', enabled: true },
                    groundTransport: { title: 'Ground Transport', enabled: true },
                }
            },
            security: {
                enabled: true,
                title: 'Security',
                items: {
                    assessment: { title: 'Assessment', enabled: true }
                }
            }
        }
    },
    city: {
        enabled: true,
        categories: {
            keyStats: {
                enabled: true,
                title: 'Key Stats',
                items: {
                    // Need to pass in a new way
                    riskZoneRating: { title: 'Risk Zone Rating', enabled: true },
                    // This is based on the array passed in the cityDetails > alerts, if the array is empty then hide, if user deselects, then pass as empty array/null
                    activeAlerts: { title: 'Active Alerts', enabled: true }
                }
            },
            overview: {
                enabled: true,
                title: 'Overview',
                items: {
                    securityOverview: { title: 'Security Overview', enabled: true },
                    orientation: { title: 'Orientation', enabled: true },
                    cityCalendar: { title: 'City Calendar', enabled: true },
                }
            },
            security: {
                enabled: true,
                title: 'Security',
                items: {
                    seekingHelp: { title: 'Seeking Help', enabled: true },
                    crime: { title: 'Crime', enabled: true },
                    socialUnrest: { title: 'Social Unrest', enabled: true },
                    terrorism: { title: 'Terrorism', enabled: true },
                    troubleSpots: { title: 'Trouble Spots', enabled: true }
                }
            },
            transport: {
                enabled: true,
                title: 'Transport',
                items: {
                    toCityCentre: { title: 'To City Centre', enabled: true },
                    taxis: { title: 'Taxis', enabled: true },
                    publicTransport: { title: 'Public Transport', enabled: true },
                    walking: { title: 'Walking', enabled: true },
                    carHire: { title: 'Car Hite', enabled: true }
                }
            },
            keyinfo: {
                enabled: true,
                title: 'Key Info',
                items: {
                    diplomaticRepresentation: { title: 'Diplomatic Representation', enabled: true },
                    emergencyMedicalCare: { title: 'Emergency Medical Care', enabled: true },
                    emergencyNumbers: { title: 'Emergency Numbers', enabled: true },
                    lodging: { title: 'Lodging', enabled: true }
                }
            }
        }
    },
    country: {
        enabled: true,
        categories: {
            keyStats: {
                enabled: true,
                title: 'Key Stats',
                items: {
                    travelRiskRating: { title: 'Travel Risk Rating', enabled: true },
                    medicalRiskRating: { title: 'Medical Risk Rating', enabled: true },
                    covidImpact: { title: 'COVID Impact', enabled: true },
                    activeAlerts: { title: 'Active Alerts', enabled: true }
                }
            },
            overview: {
                enabled: true,
                title: 'Overview',
                items: {
                    assessment: { title: 'Assessment', enabled: true },
                    conclusion: { title: 'Conclusion', enabled: true },
                    emergencyNumbers: { title: 'Emergency Numbers', enabled: true }
                }
            },
            travel: {
                enabled: true,
                title: 'Travel',
                items: {
                    riskSummary: { title: 'Travel Risk Summary', enabled: true },
                    securityAlerts: { title: 'Travel & Security Alerts', enabled: true },
                    standingTravelAdvice: { title: 'Standing Travel Advice', enabled: true },
                    businessWomen: { title: 'Business Women', enabled: true },
                    entryExitRequirements: { title: 'Entry & Exit Requirements', enabled: true }
                }
            },
            background: {
                enabled: true,
                title: 'Background',
                items: {
                    countryRuleOfLaw: { title: 'Country Rule of Law', enabled: true },
                    countryConflict: { title: 'Country Conflict', enabled: true },
                    politicalSituation: { title: 'Political Situation', enabled: true },
                    countryCorruption: { title: 'Country Corruption', enabled: true },
                    borderConcerns: { title: 'Border Concerns', enabled: true },
                    socialUnrest: { title: 'Social Unrest', enabled: true },
                    naturalDisasters: { title: 'Natural Disasters', enabled: true },
                    recentHistory: { title: 'Recent History', enabled: true }
                }
            },
            medical: {
                enabled: true,
                title: 'Medical',
                items: {
                    waterrisk: { title: 'Water Risk', enabled: true },
                    foodrisk: { title: 'Food Risk', enabled: true },
                    vaccination: { title: 'Vaccination', enabled: true },
                    routinevaccination: { title: 'Routine Vaccination', enabled: true },
                    medicalalertteaser: { title: 'Medical Alert Teaser', enabled: true },
                    emgresponse: { title: 'Emergency Response', enabled: true },
                    outpatientcare: { title: 'Outpatient Care', enabled: true },
                    healthcarepayment: { title: 'Healthcare Payment', enabled: true },
                    dentalcare: { title: 'Dental Care', enabled: true },
                    availmeds: { title: 'Availability Medications', enabled: true },
                    bloodsupplies: { title: 'Blood Supplies', enabled: true },
                    diseases: { title: 'Diseases', enabled: true },
                    GeneralDiseaseAndPreventionContent: { title: 'General Disease & Prevention Content', enabled: true },
                    medicalReferrals: { title: 'Medical Referrals', enabled: true }
                }
            }
        }
    },
    airspace: {
        enabled: true,
        categories: {
            keyStats: {
                enabled: true,
                title: 'Key Stats',
                items: {
                    // This is basically a new property for BE to consider, but it determines values dynamicaaly from countryThreatTypes
                    flightLevelRisk: { title: 'Flight Level Risk', enabled: true },
                    countryThreatTypes: { title: 'Aircraft Weaponary Risk', enabled: true }
                }
            },
            czWarnings: { // This is based on airspaceDetails.groupedRestrictions
                enabled: true,
                title: 'CZ Warnings',
                items: {
                    czWarnings: { title: 'CZ Warnings', enabled: true }
                }
            },
            overview: {
                enabled: true,
                title: 'Overview',
                items: {
                    assessment: { title: 'Assessment', enabled: true },
                    recommendation: { title: 'Recommendation', enabled: true },
                    introduction: { title: 'Introduction', enabled: true },
                    map: { title: 'Map', enabled: true }
                }
            },
            weaponry: {
                enabled: true,
                title: 'Weaponry',
                items: {
                    introduction: { title: 'Introduction', enabled: true },
                    availability: { title: 'Availability', enabled: true },
                    directAttacks: { title: 'Direct Attacks', enabled: true },
                    documentedUseCivilAviation: { title: 'Documented Use - Civil Aviation', enabled: true },
                    documentedUseMilitaryAviation: { title: 'Documented Use - Military Aviation', enabled: true },
                    IDFAttacks: { title: 'IDF Attacks', enabled: true }
                }
            },
            aviation: {
                enabled: true,
                title: 'Aviation',
                items: {
                    summary: { title: 'Summary', enabled: true },
                    advice: { title: 'Advice', enabled: true },
                    airspaceProhibition: { title: 'Airspace Prohibition', enabled: true },
                    aviationAlerts: { title: 'Alerts', enabled: true }
                }
            }
        }
    }
}

export const REPORT_FILTER = [
    { key: 'airport', value: 'airportDetails', category: ['keyStats', 'overview', 'operations', 'security'] },
    { key: 'city', value: 'cityDetails', category: ['keyStats', 'overview', 'security', 'transport', 'keyinfo'] },
    { key: 'country', value: 'countryDetails', category: ['keyStats', 'overview', 'travel', 'background', 'medical'] },
    { key: 'airspace', value: 'airspaceDetails', category: ['keyStats', 'czWarnings', 'overview', 'weaponry', 'aviation'] }
]